import React from 'react';
import { SvgIcon } from 'core/icons';
import OptionCheckbox from './OptionCheckbox';
import OptionMsrpHeader from './OptionMsrpHeader';

const DriveTypeOption = props => {
  const { option, disabled, disclaimer, analyticsKey, onChange } = props;
  const icon = option.icon
    .replace(/\..+$/, '')
    .replace(/_/g, '-')
    .toLowerCase();
  const { selected, conflict, iconClass, id, lowestMSRP: msrp } = option;

  const onSelect = () => {
    if (!disabled && !selected) {
      onChange(option);
    }
  };

  const selectableClass = `option__selectable ${
    selected ? 'option__selectable--disabled' : ''
  }`;

  return (
    <div className="option">
      <OptionMsrpHeader
        msrp={msrp}
        disclaimer={disclaimer}
        analyticsKey={analyticsKey}
        analyticsKey2={id}
      />
      <div className="option__row">
        <div>
          <OptionCheckbox
            id={id}
            checked={selected}
            conflict={conflict}
            disabled={disabled}
            analyticsKey={analyticsKey}
            analyticsKey2={id}
            onChange={onSelect}
          />
        </div>
        <div
          onClick={onSelect}
          className={`${selectableClass} stat-checkbox`}
          data-dtm={analyticsKey}
          data-dtm2={id}>
          <SvgIcon
            name={icon}
            className={`drive-type-option__image ${iconClass}`}
          />
        </div>
        <div
          onClick={onSelect}
          className={`option__column drive-type-option__content ${selectableClass}`}>
          {id}
        </div>
      </div>
    </div>
  );
};

export default DriveTypeOption;
